module.exports = __webpack_public_path__ + "assets/img/1dadc4967cd0547d59927f0774216410.svg";